import { render, staticRenderFns } from "./NeoTagAgreement.vue?vue&type=template&id=2980d641&scoped=true&"
import script from "./NeoTagAgreement.vue?vue&type=script&lang=js&"
export * from "./NeoTagAgreement.vue?vue&type=script&lang=js&"
import style0 from "./NeoTagAgreement.vue?vue&type=style&index=0&id=2980d641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980d641",
  null
  
)

export default component.exports